/**
 * Updates the storage to be the current version
 *
 * @param {Object} storage - get,set
 * @param {Object[]} migrations - array of { mirate(storage), version }
 * @return {Number} version
 */
export default (storage, migrations) => {
  const applied = [];
  const currentVersion = storage.get('version') || 0;
  migrations
    .filter(({ version }) => version > currentVersion)
    .forEach(({ version, migration }) => {
      migration(storage);
      storage.set('version', version);
      applied.push(version);
    });
  return applied;
};



// WEBPACK FOOTER //
// ./src/services/storageMigrate.js